import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {ApplicationModuleHelperService} from '../application-module.service';

@Injectable()
export class RequireModuleGuard {

  constructor(private appModuleService: ApplicationModuleHelperService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable((observer) => {
      this.appModuleService.getActiveModules().subscribe((activeModules) => {
        for (const requiredModule of route.data.requiredModules) {
          if (!activeModules.includes(requiredModule)) {
            observer.next(false);
            observer.complete();
            return;
          }
        }
        observer.next(true);
        observer.complete();
        return;
      });
    });
  }
}
